<template>
  <div class="login-wrapper">
    <div class="login-container">
    <div class="title">TDI Admin Login</div>
    <el-button v-google-signin-button="clientId" class="google-signin-button" @click="loading=true" v-if="!loading">Continue with Google</el-button>
    <el-row v-if="loading" :gutter="0">
          <div class="loader"></div>
        </el-row>
    <el-row class="error-block">
        <el-alert v-if="invalidUser" title="Invalid User" type="error" description="This user does not have permission to access this site." show-icon></el-alert>
    </el-row>
    </div>
    <div class="footer"></div>
  </div>
</template>
<script>
export default {
  name: "sso",
  components: {},
  data() {
    return {
      clientId: process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID,
      invalidUser: false, 
      loading: false
    };
  },
  methods: {
    async OnGoogleAuthSuccess(idToken) {
      // console.log(idToken);
      try {
        this.invalidUser = false;
        let body = await this.axios({
          method: "post",
          url: process.env.VUE_APP_API_URL + "/users/auth",
          data: {
            id_token: idToken
          },
          timeout: 10000
        })
          .then(ret => {
            this.invalidUser = false; 
            console.log("success");
            localStorage.token = ret.data.data.token;
            localStorage.user_email = ret.data.data.user; 
            this.$router.push("/");
            this.loading = false; 
          })
          .catch(error => {
            this.invalidUser = true; 
            console.log(error);
            this.loading = false; 
            if (error.response) {
              console.log("server response: ", error.response);
            } else {
              alert("The server is offline.");
            }
          });
      } catch (err) {
        console.log(err);
      }
    },
    OnGoogleAuthFail(error) {
      console.log(error);
    }
  },
  mounted() {
    document.title = "TDI Admin | Login";
  }
};
</script>
<style scoped>
.title {
  /* font: 400 24pt system-ui; */
  margin: 40px;
  font-size: 24pt; 
  color: #fff;
}
.google-signin-button {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #bece23 0% 0% no-repeat padding-box;
  text-align: center;
  letter-spacing: 0.9px;
  font-size: 10pt;
  color: #ffffff;
  cursor: pointer;
  padding: 15px;
  font-family: Brandon Grotesque;
    font-weight: 300;
    -webkit-font-smoothing: antialiased;
}
.login-container {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 15rem;
}
.login-wrapper {
  font: lighter 18px/26px Brandon Grotesque;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  margin: unset !important;
  background-image: url("../assets/login_gradient_2x.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.footer {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 30px;
  background-image: url("../assets/powered_by_24G_2x.png");
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px 0px;
}
.error-block {
  margin: 20px 0px; 
  /* width: 80%;  */
  display: flex;
  align-items: center;
  justify-content: space-around;
}
</style>
